import { State } from '@/store';
import { Store } from 'vuex';

export const commitToStore = (
  store: Store<State>,
  commitArgs: { type: string; payload: any }[],
) => {
  commitArgs.map((commit) => {
    store.commit(commit.type, commit.payload);
  });
};
